import './components/table/editors';
import './static/style/app.scss';

import { components } from './components';
import { PosterTableRenderers } from './components/table/renderers';
import { getViewer, registerViewer } from './components/viewers';
import { POSTER_SERVICES_NAMESPACE } from './constants';
import PosterRoutes from './routes';
import { PosterAttributesService } from './services/attributesService';
import { CartStateService } from './services/cartState';
import { ImportModesService } from './services/importModesService';
import { PdfConverter } from './services/pdfConverter';
import { PDFDownloaderService } from './services/pdfDownloaderService';
import { SendPosterService } from './services/sendPosterService';
import { SignagesService } from './services/signagesService';
import { SignagesSynchronization } from './services/signagesSynchronization';
import { TemplatesService } from './services/templatesService';
import { ValuesService } from './services/valuesService';
import PosterModule, { NAMESPACE as POSTER_NAMESPACE } from './store/modules/poster';
import {
  NAMESPACE as SEND_POSTERS_NAMESPACE,
  SendPostersModule,
} from './store/modules/sendPosters';
import { formatters } from './utils/formatters';

/**
 * Function to install module in Vue instance
 * @params {Object} Vue: Vue instance
 * @params {Object} settings: object who contains router and store instance
 * */
export function install(Vue, settings) {
  // Create injector point
  settings.extensionPoints.registerExtensionPoint('poster', {
    tableRenderers: PosterTableRenderers,
    viewers: {
      registerViewer,
      getViewer,
    },
  });

  const formattingManager = settings.extensionPoints.getExtensionPoint('poster.engine')
    .formattingManager;
  for (const formatter of formatters) {
    formattingManager.registerFormatter(formatter.name, formatter.func);
  }

  for (const component of components) {
    Vue.component(component.name, component);
  }
  if (!settings || !settings.store || !settings.router || !settings.services || !settings.helpers) {
    throw new Error(
      'Please initialise plugin with a Vuex store, a Vue router a PiivoServices and a PiivoHelpers.'
    );
  }

  settings.router.addRoutes(PosterRoutes);

  settings.store.registerModule(POSTER_NAMESPACE, PosterModule);
  settings.store.registerModule(SEND_POSTERS_NAMESPACE, SendPostersModule);

  function addNamespacedService(serviceName, service) {
    return settings.services.addNamespacedService(POSTER_SERVICES_NAMESPACE, serviceName, service);
  }

  const templatesService = new TemplatesService();
  addNamespacedService('signagesSync', new SignagesSynchronization());
  addNamespacedService('importModes', new ImportModesService());
  addNamespacedService('PDFDownloader', new PDFDownloaderService());
  addNamespacedService('signages', new SignagesService());
  addNamespacedService('templates', templatesService);
  addNamespacedService('values', new ValuesService());
  addNamespacedService('pdfConverter', PdfConverter);
  addNamespacedService('posterAttributes', new PosterAttributesService());
  addNamespacedService('sendPosters', new SendPosterService());
  addNamespacedService('cartState', new CartStateService());

  settings.extensionPoints
    .getExtensionPoint('poster.engine')
    .componentsManager.$on(
      'error',
      templatesService.onTemplateComponentError.bind(templatesService)
    );
  settings.extensionPoints
    .getExtensionPoint('poster.engine')
    .componentsManager.$on(
      'error',
      templatesService.onTemplateComponentError.bind(templatesService)
    );
}

export default install;
